<h1 mat-dialog-title>Material hinzufügen</h1>
<app-select-material mat-dialog-content #selectMaterialComponent [ComponentData]="Dialogdata" [ShowHeadline]="false"></app-select-material>
<mat-dialog-actions class="button-wrapper">
    <button app-button Inverted Color="cancel" [mat-dialog-close]="null">Abbrechen</button>
    <button app-button (click)="selectMaterialComponent.Save()" Color="green" [IsLoading]="ls.IsLoading$ | async">Speichern</button>
</mat-dialog-actions>
